import { Alert, Result, theme } from 'antd';
import { FC } from 'react';
import { Search } from 'react-bootstrap-icons';

interface Props {}

export const SearchConsoleUrlInspectionLoadingView: FC<Props> = () => {
  const { token: { colorInfo } } = theme.useToken();

  return (
    <Alert
      type="info"
      style={{ height: 300, width: '100%' }}
      message={
        <Result
          icon={ <Search size={ 40 } color={ colorInfo }/> }
          title="Тестування опублікованої URL-адреси"
          subTitle="Це може зайняти кілька хвилин, не закривайте цю вкладку."
        />
      }
    />
  );
};
